// material
import { useMatch, useNavigate } from "react-router-dom";
import Page from "../Page";
import CustomerForm from "./CustomerForm";
import { BackButton } from "src/common/components/BackButton";
import { useAccess } from "src/hooks/useAccess.hook";
import { FEATURE } from "src/util/enums";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { alertSlice } from "src/store/alert/alert.slice";

export default function Customer() {
  const newUserMatch = useMatch("/customer/new");
  const navigate = useNavigate();
  const hasViewAccess = useAccess(FEATURE.CUSTOMERS, "V");
  const hasUpdateAccess = useAccess(FEATURE.CUSTOMERS, "U");
  const createAccess = useAccess(FEATURE.CUSTOMERS, "C");
  const dispatch = useDispatch();
  const { access } = useSelectedTeam();

  // Determine if user is in read-only mode (viewing existing record without update access)
  const isReadOnly = !newUserMatch && hasViewAccess && !hasUpdateAccess;

  useEffect(() => {
    if (!access) return; // Wait until access data loads

    // No view access at all → redirect
    if (!hasViewAccess) {
      dispatch(
        alertSlice.actions.setAlert({ open: true, message: "Not Authorized", severity: "error" })
      );
      navigate("/dashboard", { replace: true });
      return;
    }

    // Creating new customer without create access → redirect
    if (newUserMatch && !createAccess) {
      dispatch(
        alertSlice.actions.setAlert({ open: true, message: "Not Authorized", severity: "error" })
      );
      navigate("/dashboard", { replace: true });
      return;
    }
  }, [dispatch, newUserMatch, createAccess, navigate, hasViewAccess, hasUpdateAccess, access]);

  return (
    <Page>
      <BackButton
        text={
          newUserMatch
            ? "Create new customer"
            : isReadOnly
              ? "Customer Details"
              : "Edit customer details"
        }
        path="/customer"
      />
      <CustomerForm />
    </Page>
  );
}
